<template>
  <Flatfinder
    v-if="showFlatfinder"
    class="kpb-flatfinder"
    :value="data.flatfinders"
    :properties="properties"
    :suggested="$path('suggestedFlatfinder', data)"
    v-bind="$attrs"
  >
    <template #title>
      <slot name="top" />
    </template>
  </Flatfinder>
</template>

<script>
import Flatfinder from '@kvass/flatfinder'

/** Component for Kvass Flatfinder */
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    properties() {
      return KvassConfig.get('siteSettings.featuredResidentialProperties') || []
    },
    showFlatfinder() {
      return this.$path('data.flatfinders.length') && KvassConfig.get('stats.total')
    },
  },
  components: {
    Flatfinder,
  },
}
</script>
